<template>
  <div>
    <p class="text-xs text-muted-foreground">
      Showing
      <span class="font-medium text-gray-900">{{ startItem }}</span>
      –
      <span class="font-medium text-gray-900">{{ endItem }}</span>
      of
      <span class="font-medium text-gray-900">{{ totalCount }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  startItem: number
  endItem: number
  totalCount: number
}

defineProps<Props>()
</script>
